import { PageHeading } from '@traceio-org/ui';
import { AdminPage } from '../components/AdminPage';
import { AdminProblem } from '../components/AdminProblem';
import { AuditLog } from '../components/AuditLog';
import { useAbilities } from '../context';

/**
 * Audit (/audit): platform-api's audit log across organizations, newest first: changes and staff reads with
 * who, why and the fields that changed. Filters (action, actor, dates, organization) live in the address.
 */
export function AuditPage() {
  const abilities = useAbilities();
  return (
    <AdminPage title="Audit">
      <PageHeading
        title="Audit"
        description="Every change and every staff read on Trace, newest first. Reading the log is recorded too."
      />
      {abilities.readAudit ? (
        <AuditLog />
      ) : (
        <AdminProblem failure={{ kind: 'forbidden' }} subject="the audit log" />
      )}
    </AdminPage>
  );
}
